// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon-1PjUnqzg_uuy335DAAPWck"};